import {
  ImageGallery,
  ImageGalleryImage,
  useSlideLayout,
} from '@gripp/shared-ui';
import { useCallback } from 'react';
import { View } from 'react-native';
import { filesSharedStyles } from './filesSharedStyles';

export const GalleryHeaderActions = () => {
  return null;
};

export const GalleryPanel = ({
  images,
  initialIndex,
}: {
  images: ImageGalleryImage[];
  initialIndex: number;
}) => {
  const { setColumnTitle } = useSlideLayout();

  const handleImageChange = useCallback(
    (index: number) => {
      const image = images[index];
      if (image?.name) {
        const name = image.name;
        setColumnTitle(name.length > 30 ? `${name.substring(0, 27)}...` : name);
      }
    },
    [images, setColumnTitle]
  );

  if (images.length === 0) return null;

  return (
    <View style={filesSharedStyles.galleryPanel}>
      <ImageGallery
        key={`${initialIndex}-${images[0]?.id}`}
        images={images}
        initialIndex={initialIndex}
        showThumbnails={images.length > 1}
        showHeader={false}
        onImageChange={handleImageChange}
      />
    </View>
  );
};
